import { AsidePanelActionsButton } from '../../../..';
import * as React from 'react';
import { CARD_COLOR_TAGS_BUTTON } from './constants';
import {
    CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER,
    CLASS_ASIDE_PANEL_ACTIONS_POPUP
} from '../../../../asidePanel/components/AsidePanelActionsButton/constants';
import { ICardColorTagsButtonProps } from './types';
import { getAsidePanelActionsButtonTooltip } from '../../../../asidePanel/helpers/getAsidePanelActionsButtonTooltip';
import { CLASS_COLOR_PALETTE } from '../../../../../base/components/ColorPalette/constants';
import { CLASS_ACTION_MODAL } from '../../../../../base/components/ActionModal/constants';

export function CardColorTagsButton ({
    colorTags,
    isShowTooltip,
    isShow,
}: ICardColorTagsButtonProps) {
    if (!isShow) return null;
    const tooltip = isShowTooltip ? getAsidePanelActionsButtonTooltip({value: CARD_COLOR_TAGS_BUTTON}) : null;

    return (
        <>
            <AsidePanelActionsButton
                className={`
                    ${CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER}
                    ${CLASS_ASIDE_PANEL_ACTIONS_BUTTON_CONTAINER + '--colortags'}
                `}
                dropdownClassName={`${CLASS_ASIDE_PANEL_ACTIONS_POPUP}--colortags`}
                isIconHiddenOnFullSize={true}
                icon={'color-tag'}
                title={CARD_COLOR_TAGS_BUTTON}
                tooltip={tooltip}
                indicatorNumber={colorTags.length}
                isFitWindow
                notBlurClasses={[CLASS_COLOR_PALETTE + '-color-row__picker-dropdown', CLASS_ACTION_MODAL]}
                onClick={() => {
                    const button = document.querySelector(`.card-details .card-details__color-tags .${colorTags.length ? 'card-details__color-tags-tags' : 'card-details__color-tags-button'}`) as HTMLButtonElement;
                    if (button) {
                        button.click();
                    }
                }}
            >
            </AsidePanelActionsButton>
        </>
    );
}
